module.exports = __webpack_public_path__ + "static/media/origami12.e4424538.JPG";